import { Component,Output, Input,EventEmitter, OnInit } from '@angular/core';
import { ClienteService } from '../../services/cliente.service';
import swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonFunctions } from '../../utils/common-functions';

@Component({
  selector: 'app-gestiones-comparativa-mym',
  templateUrl: './gestiones-comparativa-mym.component.html',
  styleUrls: ['./gestiones-comparativa-mym.component.scss']
})
export class GestionesComparativaMymComponent implements OnInit {
  commonFunctions = CommonFunctions;
  @Output() selecttab = new EventEmitter<number>();
  @Input() clienteserviceParam: ClienteService
  ofertaseleccionadacliente
  ofertaseleccionada
  ofertamym
  onlyoneflag=false
  constructor(private ngxUiLoaderService: NgxUiLoaderService) {
    setTimeout(() => {
      this.ofertaseleccionadacliente=this.clienteserviceParam.ofertaseleccionada
      this.ofertaseleccionada = this.clienteserviceParam.ofertaseleccionada
      this.ofertamym = this.clienteserviceParam.ofertamym
      if (this.ofertaseleccionada == this.ofertamym) {
        this.onlyoneflag = true
        this.showPreguntaMyM()
      }
    }, 500);
   }

  ngOnInit(): void {
    console.log(this.clienteserviceParam.datosCliente.cliente)
  }
  selectOferta(index) {
    this.ofertaseleccionadacliente=index
  }
  guardarOferta() {
    this.clienteserviceParam.ofertaseleccionada = this.ofertaseleccionadacliente
    this.selecttab.emit(11);
  }
  verificarOferta() {
    if (this.ofertaseleccionadacliente == this.ofertaseleccionada && !this.onlyoneflag) {
      this.guardarOferta()
    } else {
      this.showPreguntaMonto()
    }
  }
  showNotification(title, message) {
    swal.fire({
      title: title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {

    })
  }
  showPreguntaMonto() {
    swal.fire({
      title: '¡Ahorro!',
      text: 'Su aporte de ahorro es de Q150, ¿Desea incrementarlo?',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        denyButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      showDenyButton: true,
      confirmButtonText: 'Si',
      denyButtonText: 'No',
    }).then(result => {
      if (result.isConfirmed) {
        this.showMontoAlert()
      } else if (result.isDenied) {
        this.guardarOferta()
      }
    })
  }
  showMontoAlert() {
    let cashout = ''
    swal.fire({
      title: 'Aporte de ahorro',
      input: 'number',
      inputLabel: 'Ingrese el nuevo monto',
      inputValue: cashout,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      showCloseButton: false,
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      heightAuto: false,
      inputValidator: result => !result && 'Por favor ingrese un monto.'||Number(result)<150&&'El monto debe ser mayor a 150.',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      confirmButtonText: 'Continuar',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.clienteserviceParam.mixAndMachMontoAhorro = result.value
        this.clienteserviceParam.ofertaseleccionada = null
        this.clienteserviceParam.ofertamym=this.clienteserviceParam.ofertasComerciales.ofertaComercial[this.ofertamym].grupoNumeroOferta
        this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard")
        this.clienteserviceParam.solicitarOferta().then(result => {
          this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
          this.selecttab.emit(12)
        }).catch(error => {
          this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
          this.showNotification('Ha ocurrido un error', 'Por favor intentalo mas tarde')
        })
      }
    })
  }
  goBack() {
    if(this.onlyoneflag){
      this.clienteserviceParam.ofertaseleccionada = null
      this.clienteserviceParam.mixAndMachMontoAhorro=0
      this.selecttab.emit(10);
    }else{
      this.selecttab.emit(12)//volver a ofertas
    }
  }
  getcuotamym() {
    return Number(this.clienteserviceParam.ofertasComerciales.ofertaComercial[this.ofertamym].cuotaNuevoCreditoConSeguro-Number(this.clienteserviceParam.ofertasComerciales.ofertaComercial[this.ofertamym].bienestarMixAndMatchAhorroMensual))
  }
  showPreguntaMyM() {
    swal.fire({
      title: '',
      text: 'Sabes que el ahorro te permitirá alcanzar tus objetivos de manera más fácil, ¿Te gustaría iniciar con una cultura de Ahorro?',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        denyButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: false,
      buttonsStyling: false,
      heightAuto: false,
      showDenyButton: true,
      confirmButtonText: 'Si',
      denyButtonText: 'No',
    }).then(result => {
      if (result.isConfirmed) {
      } else if (result.isDenied) {
        this.clienteserviceParam.ofertaseleccionada = 1
        this.clienteserviceParam.setReglasRechazoOfertaMym()
        this.selecttab.emit(11);
      }
    });
  }
}
